<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    count: {
      type: Number,
      default: 0
    },
    route:{
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title , count , route} = context.props

    const vnodes = []

    if (icon) {
      vnodes.push(<svg-icon icon-class={icon}/>)
    }

    if (title) {
      if (title.length > 5) {
        vnodes.push(<span slot='title' title={(title)}>{(title)}</span>)
      } else {
        vnodes.push(<span slot='title'>{(title)}</span>)
      }
      if (route == 'shipment' && count > 0){
        vnodes.push(
          <el-badge 
            value={count} 
            class="sub-item-badge" 
            style="top: -6px;margin-left: 5px;"  // 与文字保持间距
          />
        )
      }
      
    }
    return vnodes
  }
}
</script>

